import { useState,useEffect } from 'react';
import React from 'react';
import {NavIcon,LogoutIcon,BurgerIcon,ShieldIcon,SunIcon,MoonIcon,WarnIcon}  from '../Icons/icons'
import CompteurPlaces from './CompteurPlaces';

// ── Nav config ─────────────────────────────────────────
const NAV_ACTIONS = [
  { id: 'entree',      label: 'Entrée camion',    badge: null, badgeClass: '' },
  { id: 'liste',       label: 'Camions présents', badge: '78', badgeClass: '' },
  { id: 'signalement', label: 'Signalements',      badge: '2',  badgeClass: 'orange' },

];
const NAV_SEARCH = [
  { id: 'recherche', label: 'Recherche plaque', badge: null, badgeClass: '' },
];
const NAV_RONDE = [
  { id: 'ronde', label: 'Mode Ronde', badge: null, badgeClass: '' },
];
 

export function SidebarContent({ activeView, onNavigate, currentUser, onLogout }) {
  const NavSection = ({ title, items }) => (
    <div className="vv-nav-section">
      <span className="vv-nav-label">{title}</span>

         
      {items.map(item => (
        <button
          key={item.id}
          className={`vv-nav-item${activeView === item.id ? ' active' : ''}`}
          onClick={() => onNavigate(item.id)}
  >
    
          <NavIcon name={item.id} />
          {item.label}
          {item.badge && (
            <span className={`vv-nav-badge${item.badgeClass ? ` ${item.badgeClass}` : ''}`}>
              {item.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );

  return (
    <>
      <CompteurPlaces occupes={78} total={150} />
      <NavSection title="Actions"   items={NAV_ACTIONS} />
            <NavSection title="Ronde"     items={NAV_RONDE}   />

      <NavSection title="Recherche" items={NAV_SEARCH}  />
      <div className="vv-sidebar-footer">
        <div className="vv-user-chip">
          <div className="vv-avatar">{currentUser.initiales}</div>
          <div className="vv-user-info">
            <div className="vv-user-name">{currentUser.nom}</div>
            <div className="vv-user-role">Veilleur de nuit</div>
          </div>
          <button className="vv-logout" onClick={onLogout} title="Déconnexion">
            <LogoutIcon />
          </button>
        </div>
      </div>
    </>
  );
}

export default SidebarContent;